const theTeam = {
  title: "Our team",
  isabelle: {
    position: "Founder and English teacher",
    paragraphs: [
      'As a teacher, I sometimes left the classroom feeling frustrated and discouraged because I hadn\'t managed to capture my students’ attention and felt that I had "lost" them. I spent hours searching for methods, topics and activities that could spark their interest, convinced that part of the solution lay in differentiated instruction.',
      "That’s why I created iizenglish, a platform that enables teachers to assign different tasks to students at the same time. By addressing each learner's individual needs, iizenglish helps every student progress.",
    ],
  },
  herve: {
    position: "Co-founder and project manager",
    paragraphs: [
      "Hervé drives complex projects and led iizenglish from concept to launch.",
      "He successfully brought the project from start to finish.",
    ],
  },
  kayla: {
    position: "English teacher",
    paragraphs: [
      "Native English teacher.",
      "She is committed to finding effective strategies and tools to help every student succeed and reach their full potential.",
    ],
  },
  developers: {
    position: "Software developers",
    paragraphs: [
      "They code but also «decode» to make iizenglish intuitive and easy to use.",
    ],
  },
  bodz: {
    position: 'an Artist and our visual "translator"',
    paragraphs: [
      "He created the 1275 drawings in the app/",
      "{'@'}lunetlautre.fr",
    ],
  },
  bottomSection: {
    title: "LAST BUT NOT LEAST:",
    leftSection: {
      title: "THE PIONEERS",
      content: "Our beta-version users",
    },
    rightSection: {
      title: "OUR STRONG SUPPORTERS",
      content:
        "All the parents and students who have shared their experiences.",
    },
  },
};

export default theTeam;
